import { UseFormReturn } from 'react-hook-form'

const useFormUtils = <T extends object>(form: UseFormReturn<T, unknown, undefined>) => {
    const { reset, watch } = form

    const resetForm = (resetData: Partial<T>) => {
        reset({
            ...watch(),
            ...resetData,
        })
    }

    return {
        resetForm,
    }
}

export default useFormUtils
